import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Dialog } from './../../common/dialog';

class Delete extends Component {
    static propTypes = {
        handleDeleteElement: PropTypes.func,
        hideDelete: PropTypes.func,
        isDeleting: PropTypes.bool
    };

    render() {
        const { hideDelete, handleDeleteElement, isDeleting } = this.props;

        let deleteButtonLabel = 'Delete';
        if (isDeleting) {
            deleteButtonLabel = <i className="fas fa-circle-notch fa-spin" />;
        }

        let actions = [
            <button key="save-button" className="btn btn-light btn-sm action-button" onClick={handleDeleteElement} disabled={isDeleting}>{deleteButtonLabel}</button>,
            <button key="close-button" className="btn btn-light btn-sm action-button-cancel" onClick={hideDelete}>Cancel</button>
        ];
        return (
            <Dialog
                name="delete"
                modal={false}
                actions={actions}
            >
                <div className="delete-container">
                    Are you sure to delete this item? This action cannot be undone
                </div>
            </Dialog>
        );
    }
}

export default Delete;
